module.exports = __webpack_public_path__ + "static/media/Its1am.d224866b.gif";